import React, { useState } from "react";
import { Icon } from "@zorni/components-lib";
import styles from "./Chatbox.module.css";

const ChatBox = ({
  conversation,
  conversationLabel = "Conversation",
  messages,
  currentUserId,
  onSendMessage,
  isSending = false,
  loadMoreMessages,
  currentPage,
  totalPages,
  onBack,
}) => {
  const [reply, setReply] = useState("");

  const handleSend = () => {
    if (!reply.trim() || isSending) return;
    onSendMessage(reply);
    setReply("");
  };

  const initials = conversationLabel.slice(0, 2).toUpperCase();
  const subLabel =
    conversation?.tripReference ||
    (conversation?.id ? `#${String(conversation.id).slice(0, 8)}` : "");

  return (
    <div className={styles.chatbox}>

      {/* ── Header ── */}
      <div className={styles.chatHeader}>
        <div className={styles.chatHeaderLeft}>
          {onBack && (
            <button
              className={styles.backBtn}
              onClick={onBack}
              aria-label="Retour à la liste"
            >
              <Icon name="iconChevronLeft" size="sm" />
            </button>
          )}
          <div className={styles.chatAvatar}>
            <span>{initials}</span>
          </div>
          <div className={styles.chatHeaderInfo}>
            <span className={styles.chatName}>{conversationLabel}</span>
            {subLabel && (
              <span className={styles.chatSub}>{subLabel}</span>
            )}
          </div>
        </div>
      </div>

      {/* ── Zone messages ── */}
      <div className={styles.messages}>
        {currentPage < totalPages - 1 && (
          <button className={styles.loadMore} onClick={loadMoreMessages}>
            Charger les messages précédents
          </button>
        )}

        {!messages.length && (
          <div className={styles.emptyState}>
            Aucun message pour cette conversation.
          </div>
        )}

        {messages.map((msg, i) => {
          // transmitterId/transmitterType were removed from the Message model.
          // In a 2-party conversation, a message not addressed to the current
          // viewer must have been sent by them — receiverId still identifies
          // the recipient, so its absence/mismatch is enough to tell "mine"
          // from "theirs" without needing to know who the sender actually is.
          const isMe = Boolean(currentUserId) && msg.receiverId !== currentUserId;
          const isSendingMsg =
            msg.status === "SENDING" || msg.id?.startsWith("temp-");

          return (
            <div
              key={msg.id || i}
              className={`${styles.messageRow} ${isMe ? styles.right : styles.left}`}
            >
              {!isMe && (
                <div className={styles.avatar}>
                  <span>{initials}</span>
                </div>
              )}
              <div className={styles.messageWrap}>
                <div
                  className={`${styles.messageBubble} ${
                    isMe ? styles.bubbleOut : styles.bubbleIn
                  }`}
                >
                  <p>{msg.content}</p>
                </div>
                <span className={styles.timestamp}>
                  {isSendingMsg
                    ? "Envoi..."
                    : new Date(msg.sendingDate).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      {/* ── Barre de réponse ── */}
      <div className={styles.replyBar}>
        <div className={styles.replyPill}>
          <button className={styles.attachBtn} aria-label="Ajouter une pièce jointe" type="button">
            <Icon name="iconPlus" size="sm" />
          </button>
          <input
            type="text"
            placeholder={isSending ? "Envoi en cours..." : "Écrire votre message..."}
            value={reply}
            onChange={(e) => setReply(e.target.value)}
            disabled={isSending}
            onKeyPress={(e) => e.key === "Enter" && handleSend()}
            className={styles.replyInput}
          />
          <button
            className={styles.sendBtn}
            onClick={handleSend}
            disabled={isSending || !reply.trim()}
            aria-label="Envoyer"
            type="button"
          >
            <Icon name="iconSend" size="xs" />
          </button>
        </div>
      </div>

    </div>
  );
};

export default ChatBox;
